// If your tsconfig has "esModuleInterop": true (recommended):
import countryList from "country-list";

export type Option = { label: string; value: string };

const allCountries: Option[] = countryList
  .getData()
  .map(({ name, code }) => ({ label: name, value: code }))
  .sort((a, b) => a.label.localeCompare(b.label));

const unitedStates = allCountries.find((option) => option.value === "US");

export const COUNTRY_OPTIONS: Option[] = unitedStates
  ? [unitedStates, ...allCountries.filter((option) => option.value !== "US")]
  : allCountries;

// If you DON'T use esModuleInterop, use this import instead:
// import countryList = require("country-list");
